module.exports = __webpack_public_path__ + "static/media/27.eaa1804a.jpg";